import React from 'react'
import PropTypes from "prop-types";
import isTouchDevice from 'is-touch-device'
import './youtube.scss'

const Youtube = ({ videoId, width, height }) => {
  const videoWidth = isTouchDevice() ? 320 : width | 580;
  return (
    <div className="youtube">
      <div className="youtube__wrapper">
        <amp-youtube
          width={videoWidth}
          height={height | 270}
          layout="fixed"
          data-videoid={videoId}>
        </amp-youtube>
      </div>
    </div>
  )
};

Youtube.propTypes = {
  videoId: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default Youtube



// WEBPACK FOOTER //
// ./src/components/youtube/youtube.js